import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('CLIENTS SERVICE');

@Injectable({
  providedIn: 'root'
})
export class ClientsService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'clients' como el nombre del recurso a la clase base
    super('clients');
    log.debug('Servicio de Clientes inicializado');
  }

}
